import styled from 'styled-components';
import Arrow from '../../assets/icons/general/dropdown_arrow.svg';

const Container = styled.div`
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-right: 2rem;
  position: relative;

  &::after {
    content: ' ';
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    height: 5px;
    width: 8px;
    display: block;
    background: url(${Arrow}) center;
    pointer-events: none;
  }
`;

const Label = styled.label(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.small};
    color: ${color.grayscale[200]};
    margin: 0 1rem 0 0;
  `;
});

const SelectInput = styled.select(({ theme, hasShadow }) => {
  const { color, shadow, type } = theme;

  return `
    font-size: ${type.size.small};
    color: ${color.grayscale[0]};
    line-height: ${type.size.larger};
    padding: 12px 40px 12px 16px;
    background-color: ${color.grayscale[1000]};
    border-radius: 51px;
    ${hasShadow && `box-shadow: ${shadow.dialog};`}

    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
  `;
});

const Select = ({ name, label, options, callback, shadow, value }) => {
  return (
    <Container>
      <Label htmlFor={name}>{label}</Label>

      <SelectInput name={name} id={name} onChange={callback} hasShadow={shadow} value={value}>
        {options.map((option) => {
          return (
            <option key={`${name}-${option.value}`} value={option.value}>
              {option.display}
            </option>
          );
        })}
      </SelectInput>
    </Container>
  );
};

export default Select;
